import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SoundProvider } from './context/SoundContext';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <BrowserRouter basename="/iptagame">
        <SoundProvider>
            <App />
        </SoundProvider>
    </BrowserRouter>
);

reportWebVitals();
